// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4KTb.ui.popup{max-width:40rem;min-width:10rem;padding:0;width:max-content}.u6RA4.ui.button{min-width:2.5rem}.qvFPC{padding:1rem}.UWlkE{max-height:18rem;overflow-y:auto;padding:1rem 1.25rem}.I5IHg{display:grid;gap:.875rem 2rem;grid-template-columns:minmax(0,max-content) max-content}.ezRHf{display:contents}.K2x4d{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup": `_4KTb`,
	"trigger": `u6RA4`,
	"loader": `qvFPC`,
	"scroll": `UWlkE`,
	"list": `I5IHg`,
	"asset": `ezRHf`,
	"assetName": `K2x4d`
};
module.exports = ___CSS_LOADER_EXPORT___;
